"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[665],{

/***/ 50665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_ContactContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/uikit/Buttons/InvertedLink.tsx
var InvertedLink = __webpack_require__(80764);
// EXTERNAL MODULE: ./src/containers/data/cities.json
var cities = __webpack_require__(82606);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Contact/index.tsx







const citiesList = cities.map(city => `<a href="${city.href}">${city.name}</a>`);

const Contact = _ref => {
  let {
    image,
    title,
    description,
    action,
    href,
    alt
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    bgColor: "#EFEFF1",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
      as: index_esm/* Stack */.Kq,
      maxW: "6xl",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
        columns: {
          base: 1,
          md: 2
        },
        spacing: "l",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
          align: "flex-start",
          pt: "xxl3",
          pb: "xxl3",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            color: "baseDark",
            fontFamily: "Montserrat-SemiBold",
            fontSize: "1.25rem",
            letterSpacing: "0.6px",
            lineHeight: "26px",
            whiteSpace: "pre-wrap",
            mb: "m",
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
            color: "baseDark",
            fontFamily: "Montserrat-Medium",
            fontSize: "0.875rem",
            letterSpacing: "0.2px",
            lineHeight: "18px",
            whiteSpace: "pre-wrap",
            pb: "l",
            children: [description, /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              dangerouslySetInnerHTML: {
                __html: citiesList.join(', ')
              }
            }), "."]
          }), action && href && /*#__PURE__*/(0,jsx_runtime.jsx)(InvertedLink/* default */.Z, {
            href: href,
            action: action,
            title: alt
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
          align: "flex-start",
          display: {
            base: 'none',
            md: 'block'
          },
          position: "relative",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: image,
            alt: title,
            layout: "fill",
            loading: "lazy",
            placeholder: "empty",
            decoding: "async"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var components_Contact = (Contact);
;// CONCATENATED MODULE: ./src/containers/ContactContainer.tsx



const href = '/contatti?utm_source_button=carplanner-contact';
const ContactContainer_image = 'https://static1.carplanner.com/website/assets/maps.jpg';

const ContactContainer = _ref => {
  let {
    title,
    description,
    action
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_Contact, {
    title: title,
    description: description,
    action: action,
    href: action ? href : null,
    image: ContactContainer_image
  });
};

/* harmony default export */ var containers_ContactContainer = (ContactContainer);

/***/ }),

/***/ 80764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53918);
/* harmony import */ var src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




const StyledLink = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].a.withConfig({
  componentId: "sc-6umwyd-0"
})(["background-color:", ";color:", ";border-radius:4px;border:1px solid rgb(46,197,141);text-transform:uppercase;", ";padding:0.94rem ", " 0.88rem ", ";&:hover{background-color:", ";border-color:", ";", ";}&:active{background-color:", ";border-color:", ";", ";}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.baseWhite;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.palette.primaryGreen900;
}, src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .TextStyles.interactiveButtonsSG900SemiboldC */ .k.interactiveButtonsSG900SemiboldC, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spaces.spacing_xl;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spaces.spacing_xl;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.palette.primaryGreen900;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.palette.primaryGreen900;
}, src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .TextStyles.interactiveButtonsSWhiteSemiboldC */ .k.interactiveButtonsSWhiteSemiboldC, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.palette.primaryGreen800;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.palette.primaryGreen800;
}, src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .TextStyles.interactiveButtonsSWhiteSemiboldC */ .k.interactiveButtonsSWhiteSemiboldC);

const InvertedButtonLink = _ref9 => {
  let {
    action,
    href,
    title,
    target
  } = _ref9;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, {
    target: target || '_self',
    href: href,
    title: title || action,
    children: action
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (InvertedButtonLink);

/***/ }),

/***/ 82606:
/***/ (function(module) {

module.exports = JSON.parse('[{"name":"Bari","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/bari"},{"name":"Bergamo","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/bergamo"},{"name":"Bologna","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/bologna"},{"name":"Brescia","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/brescia"},{"name":"Catania","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/catania"},{"name":"Firenze","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/firenze"},{"name":"Genova","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/genova"},{"name":"Lecce","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/lecce"},{"name":"Lucca","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/lucca"},{"name":"Milano","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/milano"},{"name":"Modena","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/modena"},{"name":"Monza Brianza","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/monza-brianza"},{"name":"Napoli","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/napoli"},{"name":"Padova","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/padova"},{"name":"Palermo","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/palermo"},{"name":"Parma","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/parma"},{"name":"Prato","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/prato"},{"name":"Roma","image":"/images/colosseo-roma.png","href":"/noleggio-a-lungo-termine/roma"},{"name":"Torino","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/torino"},{"name":"Treviso","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/treviso"},{"name":"Udine","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/udine"},{"name":"Venezia","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/venezia"},{"name":"Verona","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/verona"},{"name":"Vicenza","image":"/images/lungomare-bari.jpg","href":"/noleggio-a-lungo-termine/vicenza"}]');

/***/ })

}]);